import { AppThunkAction } from "../..";
import { KnownAction, GET_TESTIMONIALS, Testimonials, LOADER_FOR_TESTIMONIALS, GET_OFFERMESSAGE, GET_PACKAGE_MATRIX } from "./types";
import * as httpClient from "../../../util/httpClient";

export const actionCreators = {
    getTestimonials: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const state = getState();

        const testimonialsData: Testimonials[] = [];

        if (state.testimonialsState && state.testimonialsState.isLoadingTestimonials === false && state.testimonialsState.testimonials?.length === 0) {
            dispatch({ type: LOADER_FOR_TESTIMONIALS, isLoadingTestimonials: true });

            httpClient
                .sendRequest("GET", "web/trustpilot/get-testimonials")
                .then((data) => {
                    let reviews = data;
                    reviews.forEach((element: any) => {
                        testimonialsData.push({
                            reviewStars: element["stars"],
                            reviewHeader: element["title"],
                            reviewText: element["text"],
                            reviewerName: element["reviewerName"],
                            reviewPublishDate: element["createdAt"],
                        });
                    });

                    dispatch({ type: GET_TESTIMONIALS, testimonials: testimonialsData });

                    dispatch({ type: LOADER_FOR_TESTIMONIALS, isLoadingTestimonials: false });
                })
                .catch(function (error) {
                    dispatch({ type: LOADER_FOR_TESTIMONIALS, isLoadingTestimonials: false });
                });
        }
    },
    getPromoMessage: (promoBannerText: string): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({ type: GET_OFFERMESSAGE, promoBannerText: promoBannerText });
    },
    getPackageMatrix: (packageMatrix: any): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({ type: GET_PACKAGE_MATRIX, packageMatrix: packageMatrix });
    }
};
